import { RECORDING_LIMIT_CODES, RECORDING_SERVICE_UNAVAILABLE_CODES } from '../../hooks/useVoicePractice';

/**
 * A Record & Review upload the server refused before doing anything, in its
 * own notice — never under "Recording Error" with microphone / refresh /
 * switch-browser advice, because the user's device played no part:
 *
 * - a usage or safety LIMIT (402 USAGE_BLOCKED, 429 CONVERSATION_SAFETY_LIMIT):
 *   the limit's own message;
 * - the SERVICE could not check usage (503 USAGE_AUTHORITY_UNAVAILABLE):
 *   nothing was processed or counted, and it is temporary.
 *
 * Renders nothing for any other code; the page's "Recording Error" panel
 * handles genuine recording and device errors.
 */
export function RecordingRefusalNotice({ message, code }: { message: string; code: string | null }) {
  if (code && RECORDING_LIMIT_CODES.has(code)) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-sm text-red-800" role="alert" data-testid="recording-limit-refusal">
        {message}
      </div>
    );
  }
  if (code && RECORDING_SERVICE_UNAVAILABLE_CODES.has(code)) {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-sm text-amber-900" role="alert" data-testid="recording-service-unavailable">
        <h4 className="font-medium mb-1">Usage check unavailable</h4>
        <p>{message}</p>
        <p className="mt-2">The service couldn't verify your usage right now. This is a problem on our side, not with your recording.</p>
      </div>
    );
  }
  return null;
}
